<template>
  <div class="wt-lightbox media-filtering" :class="{ '-empty': !hasAssets }">
    <template v-if="hasAssets">
      <template v-if="showUploading">
        <wt-lightbox-asset
          v-for="asset in lightboxUploadingAssets"
          :key="asset.metadata.assetUUID"
          class="media-filtering"
          :asset="asset"
          :show-actions="showActions"
          :media-co-assets="mediaCoAssets"
          :uploading="true"
          @remove-asset="ABORT_LIGHTBOX_UPLOAD_ASSET(asset)"
          @upload-done="LIGHTBOX_UPLOAD_DONE(asset)"
        />
      </template>
      <wt-lightbox-asset
        v-for="asset in selectedAssets"
        :key="asset.id"
        class="media-filtering"
        :show-actions="showActions"
        :can-add="canAdd"
        :custom-overlay-mode="customOverlayMode"
        :media-co-assets="mediaCoAssets"
        :class="{ '-selected': asset.metadata.assetUUID === selected }"
        :asset="asset"
        @preview-asset="previewAsset"
        @add="addAsset"
      />
    </template>
    <div v-else class="-empty">
      <slot name="empty"> </slot>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'wt-lightbox',

  props: {
    filter: { type: Function, required: false },
    mediaCoAssets: { type: Array, default: () => [] },
    showUploading: { type: Boolean, default: true },
    showActions: { type: Boolean, default: true },
    canAdd: { type: Boolean, default: true },
    customOverlayMode: { type: Boolean, default: false },
    selected: { type: String, default: '' },
  },

  computed: {
    ...mapState({
      lightboxUploadingAssets: (state) => state.story.lightboxUploadingAssets,
      lightboxAssets: (state) => state.story.selectedAssets,
    }),

    selectedAssets() {
      const rv = this.lightboxAssets;
      if (Array.isArray(rv) && rv.length && this.filter) {
        return rv.filter(this.filter);
      }
      return rv;
    },

    hasAssets() {
      if (this.showUploading) {
        return (
          this.selectedAssets.length || this.lightboxUploadingAssets.length
        );
      }
      return this.selectedAssets?.length;
    },
  },

  methods: {
    ...mapActions(['ABORT_LIGHTBOX_UPLOAD_ASSET', 'LIGHTBOX_UPLOAD_DONE']),

    previewAsset(asset) {
      this.$emit('preview-asset', asset);
    },

    addAsset(asset) {
      this.$emit('add-asset', asset);
    },
  },
};
</script>
